import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { ErrorHandler, NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { AccountRoutingModule } from './account/account-routing.module'
import { AccountModule } from './account/account.module'
import { AppRoutingModule } from './app-routing.module'
import { ArpioRoutingModule } from './arpio/arpio-routing.module'
import { ArpioModule } from './arpio/arpio.module'
import { AuthRoutingModule } from './auth/auth-routing.module'
import { AuthModule } from './auth/auth.module'
import { AwsMarketplaceRoutingModule } from './aws-marketplace/aws-marketplace-routing.module'
import { AwsMarketplaceModule } from './aws-marketplace/aws-marketplace.module'
import { AzureMarketplaceRoutingModule } from './azure-marketplace/azure-marketplace-routing.module'
import { AzureMarketplaceModule } from './azure-marketplace/azure-marketplace.module'
import { AdminEntryRoutingModule } from './admin/admin-entry-routing.module'
import { UiShell } from './components/ui-shell/ui-shell.component'
import { CreateAccountRoutingModule } from './create-account/create-account-routing.module'
import { CreateAccountModule } from './create-account/create-account.module'
import { AccessDeniedComponent } from './errors/components/access-denied/access-denied.component'
import { ArpioSharedModule } from './shared/arpio-shared.module'
import { NotFoundErrorComponent } from './errors/components/not-found-error/not-found-error.component'
import { GlobalErrorHandler } from './account/services/datadog-global-error-handler.service'
import { providePrimeNG } from 'primeng/config'
import { ArpioPreset } from './app-theme'

@NgModule({
  declarations: [AccessDeniedComponent, NotFoundErrorComponent, UiShell],
  bootstrap: [UiShell],
  imports: [
    BrowserModule,
    FormsModule,
    // Routing modules.  Order matters here!!!
    AuthRoutingModule,
    CreateAccountRoutingModule,
    AwsMarketplaceRoutingModule,
    AzureMarketplaceRoutingModule,
    ArpioRoutingModule,
    AdminEntryRoutingModule,
    AccountRoutingModule,
    AppRoutingModule,
    // Application modules.  These often import the routing modules,
    // so I'm putting them after those so they don't mess with the
    // order of imported routes (defined above).
    AuthModule,
    ArpioModule,
    AccountModule,
    CreateAccountModule,
    AwsMarketplaceModule,
    AzureMarketplaceModule,
    ArpioSharedModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: ArpioPreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'primeng',
          },
        },
      },
    }),
  ],
})
export class AppModule {}
